import Axios, { Response } from "../utils/Axios";

export type ContactType = {
  store_name: string;
  phone_number: string;
  hour: string;
  address: string;
  sectors: string;
};

const LandingController = {
  // 상담신청하기
  setContactUs: async (storeInquiryList: ContactType) => {
    try {
      let sUrl =
        process.env.REACT_APP_API_BEHIND_URL + "/store/sendContactUs";
      const oParams = storeInquiryList;
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: "[비하인드 상담 신청 오류]" + oErr.toString(),
        data: undefined,
      };
    }
  },
};

export default LandingController;
